import { send } from '@actual-app/core/platform/client/connection';
import { isElectron } from '@actual-app/core/shared/environment';

/**
 * Va a Google para entrar (o darse de alta: la cuenta nueva ocupa una plaza
 * o va a la lista de espera). Si sale bien, la página se va a Google y al
 * volver ya hay sesión; si no, devuelve el motivo para enseñarlo.
 * `password` solo hace falta la primera vez que se pone en marcha el
 * servidor.
 */
export async function entrarConGoogle(password = ''): Promise<string | null> {
  const { error, redirectUrl } = await send('subscribe-sign-in', {
    returnUrl: isElectron()
      ? await window.Actual.startOAuthServer()
      : window.location.origin,
    loginMethod: 'openid',
    password,
  });

  if (error || !redirectUrl) {
    return error ?? 'internal-error';
  }
  if (isElectron()) {
    window.Actual?.openURLInBrowser(redirectUrl);
  } else {
    window.location.href = redirectUrl;
  }
  return null;
}
